"use client";

import React, { useEffect, useState } from "react";
import { House, Recycle, MapPin, Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  id: 1,
  value: 1250,
  suffix: "+",
  label: "Projects Completed",
  icon: House
}, {
  id: 2,
  value: 45000,
  suffix: "",
  label: "Safety Hours",
  icon: Recycle
}, {
  id: 3,
  value: 15,
  suffix: "+",
  label: "Years Experience",
  icon: MapPin
}, {
  id: 4,
  value: 85,
  suffix: "",
  label: "Grid Experts",
  icon: Star
}];
function StatCard({
  stat,
  index
}: {
  stat: typeof stats[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const end = stat.value;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible, stat.value]);
  const Icon = stat.icon;
  return <div data-section-id="225004" data-index={index} ref={ref} className="group relative flex flex-col items-center justify-center overflow-hidden rounded-none border border-border bg-card p-8 text-center shadow-none transition-all hover:border-primary/50">
      <div className="absolute inset-0 translate-y-full bg-muted/50 transition-transform duration-500 ease-in-out group-hover:translate-y-0" />
      
      <div className="relative z-10 mb-6 rounded-none border border-primary bg-background p-4">
        <Icon className="size-8 text-primary" strokeWidth={1.5} />
      </div>
      
      <div className="relative z-10 mb-2 flex items-center font-default text-4xl font-bold text-foreground md:text-5xl">
        {count.toLocaleString()}
        <span className="text-primary">{stat.suffix}</span>
      </div>
      
      <div className="relative z-10 font-mono text-xs font-bold uppercase tracking-widest text-muted-foreground md:text-sm">
        {stat.label}
      </div>

      {}
      <div className="relative z-10 mt-4 h-1 w-full bg-muted">
        <div className="h-full bg-primary transition-all duration-1000 ease-out" style={{
        width: isVisible ? '100%' : '0%'
      }} />
      </div>
    </div>;
}
export default function ByTheNumbers() {
  return <section id="powering-the-industry" className="bg-background text-foreground">
      <div className="border-y border-border bg-background py-20 lg:py-32">
        <div className="container mx-auto px-4">
          <div className="mx-auto mb-16 max-w-3xl text-center">
            <h2 className="mb-4 font-default text-3xl font-bold uppercase tracking-tight text-foreground md:text-5xl">
              Powering the <span className="text-primary">Industry</span>
            </h2>
            <p className="font-mono text-sm text-muted-foreground">
              Precision-engineered infrastructure for commercial and industrial electrical systems.
            </p>
          </div>
          
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat, i) => <StatCard key={stat.id} stat={stat} index={i} />)}
          </div>
        </div>
      </div>
    </section>;
}